import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { vars, pxToRem, fontWeight } from '$util/theme';

const A = styled.a`
  font-weight: ${fontWeight.bold};
  font-size: ${pxToRem(14)};
  color: ${vars.quantumverse.reskinColors.neutral700};
`;

function BoldLink({ url, children, className = '', ...props }) {
  return (
    <A href={url} className={classNames('bold-link', className)} {...props}>
      {children}
    </A>
  );
}

BoldLink.propTypes = {
  url: PropTypes.string,
  children: PropTypes.any,
  className: PropTypes.string,
};

BoldLink.defaultProps = {
  url: '',
  children: '',
  className: '',
};

export default BoldLink;
